<button mat-dialog-title mat-mini-fab color="primary" tabindex="-1" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <h1>{{ 'Turbo.OneWayAdmin.FindIssueDialog.Headline' | translate : 'Find service request' }}</h1>
  <t4-container>
    <div style="width: 400px;" class="row">
      <div class="col-12">
        <mat-form-field style="width: 100%;">
          <input matInput [formControl]="txtKeywords" placeholder="{{'Turbo.OneWayAdmin.FindIssueDialog.txtKeywords' | translate : 'Enter request no or rental object'}}" (keydown.enter)="$event.stopPropagation(); handleTexFieldKeyPress($event)" />
        </mat-form-field>
        <div *ngIf="!requests">{{'Turbo.OneWayAdmin.FindIssueDialog.msgNoRequest' | translate : 'No service requests has been found'}}</div>
        <div *ngIf="requests" class="container-fluid" style="max-height: 250px; overflow: auto;">
          <div #requestList *ngFor="let item of requests" class="row" (click)="showSelectedRequest()" tabindex="0" (keydown.enter)="$event.stopPropagation(); handleEnterKey($event)">
              <div class="col-xs-12 list-item" matTooltip="{{ item.Description }}" (click)="selectedRequest = item" [ngClass]="{ 'selected': selectedRequest == item }">
                <div class="statusIcon" style="float: left; margin: 12px;" [ngClass]="{'status-green': (item.Status == 50 || item.Status == 100), 'status-red': (!item.ExpectedResolveDate || item.ExpectedResolveDate < today), 'status-yellow': (item.ExpectedResolveDate < tomorrow && item.ExpectedResolveDate >= today) }"></div>
                <span style="float: right">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus_' + item.Status | translate }}</span>
                <t4-object-link [objectId]="item.RentalObjectId"></t4-object-link><br/>
                {{ item.RequestNo }} ({{item.InsuranceId }})<br />
                {{ item.CreatedAt | date : 'yyyy-MM-dd HH:mm' }}
              </div>            
          </div>
        </div>
      </div>
    </div>
    </t4-container>
  </mat-dialog-content>
